import { Scaled } from 'react-pdf-highlighter';

export const areHighlightsOverlapping = (
  rect1: Scaled | undefined,
  rect2: Scaled | undefined,
): boolean => {
  if (!rect1 || !rect2 || rect1.pageNumber !== rect2.pageNumber) {
    return false;
  }
  return (
    rect1.x1 < rect2.x2 &&
    rect1.x2 > rect2.x1 &&
    rect1.y1 < rect2.y2 &&
    rect1.y2 > rect2.y1
  );
};

export const opacityToHex = (opacity: number): string => {
  // Clamp between 0 and 1
  const clamped = Math.max(0, Math.min(1, opacity));
  // Convert to 0–255
  const intVal = Math.round(clamped * 255);
  // Convert to hex and pad with 0 if needed
  return intVal.toString(16).padStart(2, '0');
};
